module.exports = "<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"alert alert-danger\">\n                {{$ctrl.message}}\n            </div>\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/client/app/shared/widget/invalid-status/invalid-status.html
// module id = 408
// module chunks = 0